import React, {useEffect, useState} from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";
import {useParams} from "react-router-dom";
import {CircularProgress, LinearProgress} from "@mui/material";
import {FormEditPin} from "../../../UI/Advertising/pin/edit";
import {ShowPin} from "../../../UI/Advertising/pin/show";

const ShowPinPanel = () => {
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState({
        title: "",
        description: "",
        pin_url: "",
        pin_place: "",
        views: 0,
        clicks: 0,
        device_percentages: [],
        country_percentages: [],
    });

    const getData = async () => {
        try {
            const {result, response} = await Helper.Get({
                url: `${api_Routes.PinsAdvertising.GetOne}${id}`,
            });

            if (response) {
                const pinData = response.data[0]
                setData({
                    title: pinData.title || "",
                    description: pinData.description || "",
                    pin_url: pinData.pin_url || "",
                    pin_place: pinData.pin_place || "",
                    views: pinData.views || 0,
                    clicks: pinData.clicks || 0,
                    device_percentages: pinData.device_percentages || [],
                    country_percentages: pinData.country_percentages || [],
                });
            }
        } catch (error) {
            console.error("Error fetching details:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <div>
            <PanelHead
                title={
                    isLoading ? (
                        <div className="flex items-center gap-4">
                            Show Pin <CircularProgress size={24}/>
                        </div>
                    ) : (
                        <div className="flex items-center justify-between w-full gap-4">
                            <div>Show Pin: {data?.title}</div>
                        </div>
                    )
                }
            />
            <PanelBody
                content={
                    isLoading ? (
                        <LinearProgress/>
                    ) : (
                        <ShowPin data={data} setData={setData}/>
                    )
                }
            />
        </div>
    );
};

export default React.memo(ShowPinPanel);
